import React from "react";
import { Form } from "react-bootstrap";
import { useAnalyticsFilters } from "../../context/AnalyticsFilterContext";

const FolderFilter = () => {
  const {
    selectedFolder,
    setSelectedFolder,
    folderOptions,
  } = useAnalyticsFilters();

  return (
    <Form.Select
      value={selectedFolder}
      onChange={(e) => setSelectedFolder(e.target.value)}
      style={{ width: 180 }}
    >
      <option value="All">All</option>
      {folderOptions.map((f) => (
        <option key={f} value={f}>
          {f}
        </option>
      ))}
    </Form.Select>
  );
};

export default FolderFilter;
